import { createFooterMapper } from '../../../utils/normalizeColumnDefs';
import * as FIELDS from '../../fields';
import { BROWSER_REPORT_ID } from './browserReportId';

const emptyColumns = [FIELDS.PLATFORM_CODE, FIELDS.BROWSER].map(createFooterMapper(BROWSER_REPORT_ID));

const browserReportFooterColumnDefinition = [...emptyColumns];

export default browserReportFooterColumnDefinition;
